import { render, staticRenderFns } from "./Acuerdos.vue?vue&type=template&id=0a6d9ffd&scoped=true"
import script from "./Acuerdos.vue?vue&type=script&lang=js"
export * from "./Acuerdos.vue?vue&type=script&lang=js"
import style0 from "./Acuerdos.vue?vue&type=style&index=0&id=0a6d9ffd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a6d9ffd",
  null
  
)

export default component.exports